export const STATE_CIRCLE_RADIUS = 30
export const STATE_TRIANGLE_HEIGHT = 25
export const STATE_TRIANGLE_WIDTH = 20
export const ARROWHEAD_ANGLE = Math.PI / 7
export const ARROWHEAD_LENGTH = 8
export const TRANSITION_SEPERATION = 90
export const DOT_GRID_RADIUS = 2.4
export const TEXT_PATH_OFFSET = 5
export const REFLEXIVE_Y_OFFSET = 130
export const REFLEXIVE_X_OFFSET = 75
export const PASTE_POSITION_OFFSET = 10
export const TEMPLATE_THUMBNAIL_WIDTH = 9 // em
export const PROJECT_THUMBNAIL_WIDTH = 12 // em
export const BOX_HANDLE_SIZE = 4
